export default __webpack_public_path__ + "static/media/cross.d5d684eb.svg";